import { Field } from 'formik';
import React from 'react';
import { Subsection } from '@fourthwall/components';
import { TimezoneSelect } from '@modules/Timezone/components/TimezoneSelect';
export const Timezone = () => {
    return (React.createElement(Subsection, { title: "Time zone" },
        React.createElement(Field, { component: TimezoneSelect, name: "timezone", label: "Time zone" })));
};
